import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  howManyDevicesAdviseInternet,
  onlineGamingAdviseInternet,
  peopleSimultaneouslyAdviseInternet,
  peopleWorkingFromHomeAdviseInternet,
  internetUsageInfoOnly,
  streamingVideoQualityAdviseInternet,
} from './advise-internet-steps'

export const adviseInternetScenarioA: Scenario = {
  id: 'advise-internet-a',
  initialStep: Steps.HOW_MANY_PEOPLE_SIMULTANEOUSLY,
  type: ScenarioType.ADVISE_INTERNET,
  milestones: [
    peopleSimultaneouslyAdviseInternet.id,
    howManyDevicesAdviseInternet.id,
    peopleWorkingFromHomeAdviseInternet.id,
    streamingVideoQualityAdviseInternet.id,
    onlineGamingAdviseInternet.id,
    internetUsageInfoOnly.id,
  ],
  version: '1',
  steps: [
    peopleSimultaneouslyAdviseInternet,
    howManyDevicesAdviseInternet,
    peopleWorkingFromHomeAdviseInternet,
    streamingVideoQualityAdviseInternet,
    onlineGamingAdviseInternet,
    internetUsageInfoOnly,
  ],
  weight: 1,
}
